const Header = () => {
    return (
        <header className="header">
            <h1>Natural Disaster Tracker
            </h1>
            
        </header>
    )
}

export default Header
